import React, { useRef, useState } from "react";
import { Carousel } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import prod1video from "../../Images/prod1video.mp4";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
const contentStyle = {
  margin: 0,
  height: "550px",
  color: "#fff",
  lineHeight: "160px",
  textAlign: "center",
  background: "#364d79",
};

export default function SkinCare() {
  const { t, i18n } = useTranslation();
  const { categoryNumber } = useParams();

  const carouselRef = useRef(null);
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [showArrows, setShowArrows] = useState(false);

  const toggleMute = () => {
    const video = videoRef.current;
    video.muted = !video.muted;
    setIsMuted(video.muted);
  };

  const handleVideoEnd = () => {
    const video = videoRef.current;
    video.currentTime = 0;
    video.play();
  };

  const prevSlide = () => {
    carouselRef.current.prev();
  };

  const nextSlide = () => {
    carouselRef.current.next();
  };

  const handleMouseEnter = () => {
    setShowArrows(true);
  };

  const handleMouseLeave = () => {
    setShowArrows(false);
  };

  return (
    <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
      <div style={{ backgroundColor: "red", width: "20%", height: 100 }}></div>
      <div style={{ backgroundColor: "green", width: "80%" }}>
        <div
          style={{ position: "relative" }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Carousel ref={carouselRef} arrows={false} infinite={true}>
            <div>
              <div style={{ position: "relative" }}>
                <video
                  ref={videoRef}
                  height="550"
                  width="100%"
                  autoPlay
                  muted
                  controls={false}
                  onEnded={handleVideoEnd}
                >
                  <source src={prod1video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <button
                  onClick={toggleMute}
                  style={{
                    position: "absolute",
                    top: "10px", // Set the top distance from the top of the video
                    right: "10px", // Set the right distance from the right side of the video
                    background: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    border: "none",
                    padding: "10px",
                    cursor: "pointer",
                  }}
                >
                  {isMuted ? "Unmute" : "Mute"}
                </button>
              </div>
            </div>
            <div>
              <h3 style={contentStyle}>2</h3>
            </div>
            <div>
              <h3 style={contentStyle}>3</h3>
            </div>
            <div>
              <h3 style={contentStyle}>4</h3>
            </div>
          </Carousel>

          {/* Custom Previous Arrow */}
          {showArrows && (
            <div
              onClick={prevSlide}
              style={{
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
                left: "10px",
                zIndex: 2,
                cursor: "pointer",
                background: "rgba(0, 0, 0, 0.5)",
                padding: "10px",
                borderRadius: "50%",
              }}
            >
              <LeftOutlined style={{ fontSize: "20px", color: "white" }} />
            </div>
          )}

          {/* Custom Next Arrow */}
          {showArrows && (
            <div
              onClick={nextSlide}
              style={{
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
                right: "10px",
                zIndex: 2,
                cursor: "pointer",
                background: "rgba(0, 0, 0, 0.5)",
                padding: "10px",
                borderRadius: "50%",
              }}
            >
              <RightOutlined style={{ fontSize: "20px", color: "white" }} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
